import { useContext, useState } from 'react';
import { appContext } from '../../../../AppContext';

export const ValidateButton = ({
  abortController,
  // handlePayment,
  verifyBtnText,
  handleDataValidation,
}) => {
  const { files, validateState, validationComplete, deletingFile } = useContext(appContext);
  const [cancelInProgress, setCancelInProgress] = useState(false);

  const handleCancel = () => {
    setCancelInProgress(true);
    abortController.abort(); // Stop validation immediately
  };

  const handleSubmit = async () => {
    // handlePayment();
  };

  return (
    <>
      {files.length > 0 && validateState && !validationComplete ? (
        <></>
      ) : (
        // <button
        //   className="btn-primary bg-c-black-c-2023  hover:bg-slate-grey "
        //   onClick={handleCancel}
        //   disabled={cancelInProgress}
        // >
        //   {cancelInProgress ? 'Cancelling...' : 'Cancel'}
        // </button>
        <button
          disabled={
            (validateState && !validationComplete) ||
            (!validateState && validationComplete) ||
            files.length === 0 ||
            files.some((file) => file.progress !== 'Ready for submit') ||
            deletingFile
          }
          className={`btn-primary text-black 
              ${
                // a: if NOT validating and validation complete
                // b: if NOT validating and validation NOT complete and files length 0 (default)
                // c: if NOT validating and validation NOT complete and files length greater than 0
                // d: if validating
                !validateState
                  ? validationComplete
                    ? 'cursor-default' //a
                    : files.length <= 0 ||
                      files.some((file) => file.progress !== 'Ready for submit') ||
                      deletingFile
                    ? 'bg-brown-orange cursor-not-allowed ' //b
                    : 'bg-minima-orange-2023 cursor-pointer hover:bg-minima-orange-light transition-colors duration-600 ease-in-out' //c
                  : 'bg-white cursor-default' //d
              }
              `}
          onClick={() => handleDataValidation()}
          // onClick={verifyBtnText === 'Verify' ? handleSubmit : handleCombine}
        >
          {verifyBtnText}
        </button>
      )}
    </>
  );
};
